import { TbCheck, TbCopy, TbDownload, TbExternalLink, TbFolder, TbShare3 } from "solid-icons/tb";
import type { ParentComponent } from "solid-js";
import { useI18n } from "~/i18n";
import { GHOST_BUTTON } from "./chief";

/**
 * The Summary tab of a Live Session that has ended: the project, the title,
 * how long it ran, the row of what to do with it, and what the scene puts
 * under that.
 */
export const SummaryPage: ParentComponent<{ project: string; title: string; duration: string }> = (props) => {
  const { t } = useI18n();
  return (
    <div class="mx-auto flex max-w-184 flex-col gap-4 px-6 pt-6">
      <div class="flex flex-col gap-1.5">
        <span class="flex items-center gap-1.5 text-xs text-muted-text">
          <TbCheck class="size-3.5" aria-hidden="true" />
          {props.project}
        </span>
        <h2 class="truncate text-[1.625rem] font-semibold tracking-[-0.019em] text-primary-text">{props.title}</h2>
        <span class="text-xs text-muted-text">
          {t("marketing.mock.summary.ended")} · {props.duration}
        </span>
        <div class="mt-2 flex flex-wrap items-center gap-2">
          <span class={GHOST_BUTTON}>
            <TbShare3 class="size-3.5" aria-hidden="true" />
            {t("marketing.mock.sheet.share")}
          </span>
          <span class={GHOST_BUTTON}>
            <TbCopy class="size-3.5" aria-hidden="true" />
            {t("marketing.mock.sheet.copy")}
          </span>
          <span class={GHOST_BUTTON}>
            <TbDownload class="size-3.5" aria-hidden="true" />
            {t("marketing.mock.sheet.download")}
          </span>
          <span class={`${GHOST_BUTTON} hidden @2xl:inline-flex`}>
            <TbFolder class="size-3.5 text-muted-text" aria-hidden="true" />
            {props.project}
          </span>
          <span class={`${GHOST_BUTTON} hidden @2xl:inline-flex`}>
            <TbExternalLink class="size-3.5" aria-hidden="true" />
            {t("marketing.mock.sheet.open_browser")}
          </span>
        </div>
      </div>
      {props.children}
    </div>
  );
};
